const initial = (state = window.__INITIAL, action) => {
    // inject initial data in base Django template
    return state
}

export default initial
